import DataTablePage from 'components/DataTablePage';
import { Navigate } from 'react-router-dom';
import { Can } from 'context';
import { suspiciousColumnData } from 'data/suspiciousColumnData';
import { useState } from 'react';
import { getSuspicious } from 'services/suspicious/get-suspicious';

function Suspicious() {
  //   const [filters, setFilters] = useState({ search: '', startDate: '', endDate: '' });
  return (
    <>
      <Can I='read' a='suspicious'>
        <DataTablePage
          title='Suspicious actions'
          //   canSearch
          //   canFilter
          fetchData={getSuspicious}
          queryKey='suspicious'
          columnData={suspiciousColumnData}
          object={'suspicious'}
          showOnly
          noActions={true}
          //   filtersComponent={<DateFilterComponent filters={filters} setFilters={setFilters} />}
          //   filters={filters}
        />
      </Can>
      <Can not I='read' a='suspicious'>
        <Navigate to='/dashboard' replace />
      </Can>
    </>
  );
}

export default Suspicious;
